import { combineReducers } from "@reduxjs/toolkit";
import commonReducer from "./commonReducer";
import singleCreateRequestReducer from "./singleCreateRequestReducer";
import bulkCreateRequestReducer from "./bulkCreateRequestReducer";
import {unifiedInventoryMovementReducer} from "./unifiedInventoryMovementReducer";
import { consumptionPreferenceReducer } from "./consumptionPreferenceReducer";
import { configureRackBOMOverrideReducer } from "./configureRackBOMOverrideReducer";

const rootReducer = combineReducers({
    commonState: commonReducer,
    singleCreateRequestDetails: singleCreateRequestReducer,
    bulkCreateRequestDetails: bulkCreateRequestReducer,
    unifiedInventoryMovementDetails: unifiedInventoryMovementReducer,
    consumptionPreferenceDetails: consumptionPreferenceReducer,
    configureRackBOMOverrideDetails: configureRackBOMOverrideReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;